import React, { useState } from "react";
import { Button, Modal } from "antd";
import QuizModal from "./QuizModal";
import "./PropertyQuiz.css"

const PropertyQuizSection = () => {
  const [openQuiz, setOpenQuiz] = useState(false);

  return (
    <>
      <section className="quiz-section">
        <h2 className="quiz-heading">
          Let's Find a Property That Feels Right.
        </h2>
        <p className="quiz-subheading">
          Take our 2-minute quiz and get personalized property
          recommendations tailored to your needs.
        </p>

        <Button
          className="quiz-btn"
          onClick={() => setOpenQuiz(true)}
        >
          Start the Quiz
        </Button>
      </section>

      <Modal
        open={openQuiz}
        footer={null}
        width={720}
        onCancel={() => setOpenQuiz(false)}
        destroyOnClose
      >
        <QuizModal onClose={() => setOpenQuiz(false)} />
      </Modal>
    </>
  );
};

export default PropertyQuizSection;
